import React, { useEffect, useReducer, useRef } from "react";
import { useIntl } from "react-intl";
import styles from "./header_footer.style";
import { makeStyles } from "tss-react/mui";
import { produce } from "immer";
import { CircularProgress, Button, Grid, Badge } from "@mui/material";
import route_map from "../config/route_map";
import { Iconfont } from "@/lib";
import g_styles from "@/components/public.style";
import { useUserInfo } from "@/model/useUserInfo";
import { usePageMode } from "@/model/usePageMode";
import cookie from "@/utils/cookie";
import { message } from "@/lib";
import BigNumber from "bignumber.js";
import { useRequest } from "ahooks";
import Logo_light from "@/assets/logo_light.png";
import Logo_dark from "@/assets/logo_dark.png";
import arrowDown from "@/assets/svg/arrowDown.svg";
import menu from "@/assets/svg/menu.svg";
import download from "@/assets/svg/download.svg";
import SwitchThemeRC from "@/components/switchTheme";
import { useTheme } from "@mui/material/styles";
import SwitchLangRC from "@/components/switchLang";
import DownloadPopoverRC from "@/components/download_popover";
import svg_message from "@/assets/svg/message.svg";
import svg_contract from "@/assets/svg/contract.svg";
import C2C_light from "@/assets/svg/C2C_light.svg";
import C2C_night from "@/assets/svg/C2C_night.svg";
import quicktrade_light from "@/assets/svg/quicktrade_light.svg";
import quicktrade_night from "@/assets/svg/quicktrade_night.svg";
import svg_right from "@/assets/svg/right.svg";

import svg_fee from "@/assets/svg/header-fee.svg";
import svg_fee_l1 from "@/assets/svg/header-fee-l1.svg";
import svg_c2c from "@/assets/svg/header-c2c.svg";
import svg_invite from "@/assets/svg/header-invite.svg";
import svg_api from "@/assets/svg/header-api.svg";
import svg_logout from "@/assets/svg/header-logout.svg";
import svg_copy from "@/assets/svg/copy.svg";

import wallet_icon from "@/assets/svg/wallet.svg";
import spot_icon from "@/assets/svg/spot.svg";
import c2c_icon from "@/assets/svg/c2c.svg";
import futures_icon from "@/assets/svg/futures.svg";

import { ReactComponent as Svgbonus } from "@/assets/svg/bonus.svg";

import service from "@/services/userinfo";
import { CopyToClipboard } from "react-copy-to-clipboard";

const useStyles = makeStyles()((theme) => ({
  ...g_styles(theme),
  ...styles(theme),
}));

const initState = {
  open_download: false,
  open_otc: false,
  muilt_menu_hover: false,
  message: [],
  menu_list: [],
  show_menu_list: [],
  public_info: {},
  stats_rate: {},
  langArr: [],
  rateArr: [],
  isEnter: null,
};
const reducer = produce((draft, action = { paylod: {}, type: "@@INTT" }) => {
  const { type, payload } = action;
  switch (type) {
    default:
      Object.keys(payload).map((item) => {
        draft[item] = payload[item];
      });
  }
}, initState);

let timer = null;
function HeaderRC() {
  const intl = useIntl();
  const { classes, cx } = useStyles();
  const [state, dispatch] = useReducer(reducer, initState);
  const { palette } = useTheme();
  const ref_download = useRef();
  const { userinfo, userinfo_loading, logoutFn } = useUserInfo();
  const { bodySize, mode, appdownload, changeRate } = usePageMode();
  const ref_otc = useRef();
  const ref_assets = useRef();

  const { loading, runAsync } = useRequest(service.message_noread, {
    manual: true,
  });
  const getIndexConfig = async () => {
    try {
      const res = await runAsync({
        payload: {},
      });
      if (res.code == 0) {
        dispatch({
          payload: {
            message: res.data?.userMessageList,
          },
        });
      }
    } catch (e) {}
  };
  const { loading: rateLoading, runAsync: runAsyncStatsRate } = useRequest(service.getStatsRate, {
    manual: true,
  });
  const getStatsRate = async () => {
    try {
      const res = await runAsyncStatsRate({
        payload: {},
      });
      if (res.code == 0) {
        const rateData = res.data;
        const { isShowKorean } = userinfo;

        const is_rate = (_rate) => {
          if (rateData[_rate]) {
            return true;
          } else {
            return false;
          }
        };
        const c_rate = cookie.read("curr_rate");
        const c_lan = cookie.read("lan");
        const default_lans = state?.public_info?.market?.default_lan || {};

        if (state?.public_info?.market?.default_lan) {
          let r_def = "USD";

          if (c_lan) {
            const lan = default_lans[c_lan] || "";
            if (lan && is_rate(lan)) {
              r_def = lan;
            }
          }
          if (c_rate) {
            if (is_rate(c_rate)) r_def = c_rate;
          }
          changeRate(r_def);
          cookie.write("curr_rate", r_def);
        }

        // 判断是否有韩语权限，没有也不展示韩语汇率
        let currentRate = rateData;
        if (!isShowKorean) {
          Object.keys(rateData).map((key) => {
            if (key.indexOf("KRW") > -1) {
              delete currentRate[key];
            }
          });
        }
        dispatch({
          payload: {
            stats_rate: currentRate || {},
          },
        });
      }
    } catch (e) {}
  };
  useEffect(() => {
    getPublicInfoV4();
    getIndexConfig();
    getIndexV5Config();
    getStatsRate();
  }, []);

  useEffect(() => {
    getStatsRate();
  }, [userinfo, state?.public_info]);

  const logout = async (e) => {
    e.preventDefault();
    try {
      const res = await logoutFn.runAsync({
        payload: {},
      });
      if (res.code == 0) {
        window.location.href = route_map.login;
      } else {
        message.error(res.msg);
      }
    } catch (e) {
      message.error(e.message);
    }
  };
  const { loading: loading_info_v4, runAsync: runAsyncInfoV4 } = useRequest(service.public_info_v4, { manual: true });
  const getPublicInfoV4 = async () => {
    try {
      const res = await runAsyncInfoV4({
        payload: {},
      });
      console.log(res);
      if (res.code == 0) {
        console.log(res);
        dispatch({
          payload: {
            public_info: res.data || {},
          },
        });
      }
    } catch (e) {}
  };
  const { loading: loading_v5, runAsync: runAsyncV5 } = useRequest(service.index_v5, { manual: true });
  const getIndexV5Config = async () => {
    try {
      const res = await runAsyncV5({
        payload: {},
      });
      if (res.code == 0) {
        const path = window.location.href.match(/[a-z]+_[A-Z]+/);
        let lang = path && path.length ? path[0] : cookie.read("lan") || "en_US";
        let menu_list = [];
        (res.data?.menu_list || []).map((item) => {
          if (item.langKey == lang) {
            menu_list.push(item);
          }
        });
        menu_list
          .sort((a, b) => a.sort - b.sort)
          .map((item) => {
            if (item && item.templateBannerList.length > 0) {
              item.templateBannerList.sort((a, b) => a.sort - b.sort);
            }
            return item;
          });
        dispatch({
          payload: {
            menu_list,
          },
        });
      }
    } catch (e) {}
  };
  const headerLink = () => {
    let linkurl = state.public_info.url;
    let lang = cookie.read("lan") || "en_US";
    if (process.env.NODE_ENV === "development") {
      return {
        home: "/ex/",
        trade: linkurl.exUrl ? "/ex/zh_CN/trade" : "",
        market: linkurl.exUrl ? "/ex/zh_CN/market" : "",
        lever: "/ex/zh_CN/margin",
        otc: linkurl.otcUrl ? "/otc/zh_CN/" : "",
        co: linkurl.coUrl ? "/co/zh_CN/trade" : "",
        proTrade: "/ex/zh_CN/proTrade",
        proLever: "/ex/zh_CN/proTradeMargin",
        proSwap: linkurl.coUrl ? "/co/zh_CN/proSwap" : "",
        exUrl: "/ex/zh_CN",
        otcUrl: linkurl.otcUrl ? "/otc/zh_CN" : "",
        coUrl: linkurl.coUrl ? "/co/zh_CN/" : "",
      };
    }
    if (state.public_info) {
      return {
        home: linkurl.exUrl ? `${linkurl.exUrl}/` : "/",
        trade: linkurl.exUrl ? `${linkurl.exUrl}/trade` : "",
        proTrade: linkurl.exUrl ? `${linkurl.exUrl}/proTrade` : "",
        market: linkurl.exUrl ? `${linkurl.exUrl}/market` : "",
        otc: linkurl.otcUrl ? `${linkurl.otcUrl}/` : "",
        lever: linkurl.exUrl ? `${linkurl.exUrl}/margin` : "",
        proLever: linkurl.exUrl ? `${linkurl.exUrl}/proTradeMargin` : "",
        co: linkurl.coUrl ? `${linkurl.coUrl}/trade` : "",
        proSwap: linkurl.coUrl ? `${linkurl.coUrl}/proSwap` : "",
        exUrl: linkurl.exUrl ? `${linkurl.exUrl}/${lang}` : "",
        otcUrl: linkurl.otcUrl ? `${linkurl.otcUrl}/${lang}` : "",
        coUrl: linkurl.coUrl ? `${linkurl.coUrl}/${lang}` : "",
      };
    }
    return "";
  };
  useEffect(() => {
    if (!state.public_info?.lan) {
      return;
    }
    let list = [...state.public_info.lan.lanList];
    let rates = [];
    if (state.public_info?.lan) {
      const filterList = [...state.public_info.lan.lanList].filter((item) => item.id !== "ko_KR");
      if (userinfo) {
        // 是否展示韩文
        const { isShowKorean } = userinfo;
        if (isShowKorean) {
          list = state.public_info.lan.lanList;
        } else {
          list = filterList;
        }
      } else {
        list = filterList;
      }
    }
    if (state.stats_rate) {
      const rate = state.stats_rate;
      Object.keys(rate).forEach((key) => {
        if (key !== "default_lan") {
          rates.push({
            langKey: key,
            langName: key,
            lang_coin: key,
            lang_logo: rate[key]?.legal_coin,
          });
        }
      });
    }
    dispatch({
      payload: {
        langArr: list,
        rateArr: rates,
      },
    });
  }, [state.public_info?.lan, userinfo, state.stats_rate]);

  useEffect(() => {
    if (!state.public_info.url || !state.menu_list.length) {
      return;
    }
    let headerLink_ = headerLink();
    if (headerLink_) {
      const formatList = state.menu_list.map((item) => {
        const type = item.menuType ? item.menuType.toString() : "";
        const nav = JSON.parse(JSON.stringify(item));
        if (item.httpUrl.indexOf("http") > -1) {
          nav.httpUrl = item.httpUrl;
        } else {
          if (type === "1") {
            nav.httpUrl = `${headerLink_.exUrl}${item.httpUrl}`;
          } else if (type === "2") {
            nav.httpUrl = `${headerLink_.otcUrl}${item.httpUrl}`;
          } else if (type === "3") {
            nav.httpUrl = `${headerLink_.coUrl}${item.httpUrl}`;
          }
        }

        if (item.templateBannerList && item.templateBannerList.length) {
          nav.childList = item.templateBannerList.map((child) => {
            const subType = child.menuType ? child.menuType.toString() : "";
            const subNav = JSON.parse(JSON.stringify(child));
            if (child.httpUrl.indexOf("http") > -1) {
              subNav.httpUrl = child.httpUrl;
            } else {
              if (subType === "1") {
                subNav.httpUrl =
                  child.target && child.target === "black" ? child.httpUrl : `${headerLink_.exUrl}${child.httpUrl}`;
              } else if (subType === "2") {
                subNav.httpUrl =
                  child.target && child.target === "black" ? child.httpUrl : `${headerLink_.otcUrl}${child.httpUrl}`;
              } else if (subType === "3") {
                subNav.httpUrl =
                  child.target && child.target === "black" ? child.httpUrl : `${headerLink_.coUrl}${child.httpUrl}`;
              }
            }
            return subNav;
          });
        }
        return nav;
      });
      dispatch({
        payload: {
          show_menu_list: formatList,
        },
      });
    }
  }, [state.public_info?.url, state.menu_list]);
  const mouseEnter = (id) => {
    clearTimeout(timer);
    timer = null;
    dispatch({
      payload: {
        isEnter: id,
      },
    });
  };
  const mouseLeave = () => {
    timer = setTimeout(() => {
      dispatch({
        payload: {
          isEnter: null,
        },
      });
    }, 50);
  };
  const copy = () => {
    message.success(intl.formatMessage({ id: "rewardsCenter.copySuccess" }));
  };

  return (
    <header className={classes.header}>
      <div className={classes.logo}>
        <a href={route_map.index}>
          {mode === "dark" ? (
            <img src={Logo_dark} width="110" height="24" alt="Logo" />
          ) : (
            <img src={Logo_light} width="110" height="24" alt="Logo" />
          )}
        </a>
      </div>
      <div>
        {window.voox_co ? (
          ""
        ) : window.innerWidth <= 1200 ? (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className={classes.header_popover_btn}
            onMouseEnter={() => mouseEnter("menu")}
            onMouseLeave={mouseLeave}
          >
            <svg data-src={menu} width={24} height={24}></svg>
            <div
              className={cx(
                "header_popover",
                classes.menu_popover,
                state.isEnter === "menu" ? classes.showPopover : ""
              )}
              style={{ left: 0, top: 23 }}
            >
              {state.show_menu_list && state.show_menu_list.length ? (
                <ul className={classes.menu2}>
                  {state.show_menu_list.map((item, index) => {
                    return (
                      <React.Fragment key={item.id}>
                        <li>
                          <a href={item.httpUrl}>{item.title}</a>
                          {item.childList && item.childList.length ? (
                            <svg data-src={arrowDown} width={16} height={16}></svg>
                          ) : (
                            ""
                          )}
                        </li>
                        {item.childList && item.childList.length
                          ? item.childList.map((sub, i) => {
                              return (
                                <div className="sub">
                                  <a href={sub.httpUrl}>{sub.title}</a>
                                </div>
                              );
                            })
                          : ""}
                      </React.Fragment>
                    );
                  })}
                </ul>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <Grid container className={classes.menu}>
            {state.show_menu_list && state.show_menu_list.length
              ? state.show_menu_list.map((item, index) => {
                  if (item.childList && item.childList.length) {
                    return (
                      <Grid item key={`item${index}`}>
                        <div
                          className={classes.header_popover_btn}
                          style={{ height: 24 }}
                          onMouseEnter={() => mouseEnter(item.id)}
                          onMouseLeave={mouseLeave}
                        >
                          <a href={item.httpUrl} className={cx(classes.muilt_menu)}>
                            <strong>{item.title}</strong>
                            <svg data-src={arrowDown} width={16} height={16}></svg>
                          </a>
                          <div
                            className={cx("header_popover", state.isEnter === item.id ? classes.showPopover : "")}
                            style={{ left: 0, top: 23 }}
                          >
                            {item.childList && item.childList.length
                              ? item.childList.map((sub, i) => {
                                  return (
                                    <div className={classes.quick_c2c} key={`sub${i}`}>
                                      <a className="item" href={sub.httpUrl}>
                                        <img src={mode == "light" ? sub.imageUrl : sub.logoNavDark} alt="" />
                                        <div>
                                          <strong>{sub.title}</strong>
                                          <p>{sub.subtitle}</p>
                                        </div>
                                        <span>
                                          <svg data-src={svg_right} />
                                        </span>
                                      </a>
                                    </div>
                                  );
                                })
                              : ""}
                          </div>
                        </div>
                      </Grid>
                    );
                  } else {
                    return (
                      <Grid item key={`item${index}`}>
                        <a href={item.httpUrl} className={cx(classes.muilt_menu)}>
                          <strong>{item.title}</strong>
                        </a>
                      </Grid>
                    );
                  }
                })
              : ""}
            {/* <Grid item>
              <div className={classes.header_popover_btn} style={{ height: 24 }}>
                <a href={route_map.c2c} className={cx(classes.muilt_menu)}>
                  <strong>{intl.formatMessage({ id: "Buy Crypto" })}</strong>
                  <svg data-src={arrowDown} width={16} height={16}></svg>
                </a>
                <div
                  className={"header_popover"}
                  style={{ left: 0, top: 23 }} */}
            {/* // onMouseEnter={() => {
                  //   dispatch({
                  //     payload: {
                  //       muilt_menu_hover: true,
                  //     },
                  //   });
                  // }}
                  // onMouseLeave={() => {
                  //   dispatch({
                  //     payload: {
                  //       muilt_menu_hover: false,
                  //     },
                  //   });
                  // }}
                // >
                //   <div className={classes.quick_c2c}> */}
            {/* <a className="item" href={route_map.otc}>
                    {mode == "light" ? <svg data-src={quicktrade_light} /> : <svg data-src={quicktrade_night} />}
                    <div>
                      <strong>{intl.formatMessage({ id: "header.quicktrade" })}</strong>
                      <p>{intl.formatMessage({ id: "header.quicktrade.desc" })}</p>
                    </div>
                    <span>
                      <svg data-src={svg_right} />
                    </span>
                  </a> */}
            {/* <a className="item" href={route_map.c2c}>
                      {mode == "light" ? <svg data-src={C2C_light} /> : <svg data-src={C2C_night} />}
                      <div>
                        <strong>{intl.formatMessage({ id: "header.C2C" })}</strong>
                        <p>{intl.formatMessage({ id: "header.C2C.desc" })}</p>
                      </div>
                      <span>
                        <svg data-src={svg_right} />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </Grid> */}
            {/* <Grid item>
              <a href={route_map.market}>
                <strong>{intl.formatMessage({ id: "Market" })}</strong>
              </a>
            </Grid>
            <Grid item>
              <a href={route_map.trade}>
                <strong>{intl.formatMessage({ id: "Spot" })}</strong>
              </a>
            </Grid>
            <Grid item>
              <a href={route_map.futures}>
                <strong>{intl.formatMessage({ id: "Futures" })}</strong>
              </a>
            </Grid> */}
            {/*<Grid item>
            <a href={route_map.kol}>
              <strong>{intl.formatMessage({ id: "koltrade" })}</strong>
            </a>
          </Grid>
           <Grid item>
            <a href={route_map.innovation}>
              <strong>{intl.formatMessage({ id: "innovation" })}</strong>
            </a>
          </Grid> */}
            {/* <Grid item>
              <a href={route_map.bonus}>
                <strong>{intl.formatMessage({ id: "Bonus" })}</strong>
              </a>
            </Grid>
            <Grid item>
              <a href={route_map.agent}>
                <strong>{intl.formatMessage({ id: "Agent" })}</strong>
              </a>
            </Grid> */}
          </Grid>
        )}
      </div>
      <div style={{ flex: 1 }}></div>
      <div className={classes.right}>
        {userinfo_loading ? (
          <div className={classes.unlogin}>
            <CircularProgress size={14} />
          </div>
        ) : !userinfo.id ? (
          <div className={classes.unlogin}>
            {window.voox_co ? (
              ""
            ) : (
              <>
                <a href={route_map.login} className={classes.login_btn}>
                  {intl.formatMessage({ id: "Log in" })}
                </a>
                <Button
                  href={route_map.register}
                  variant="outlined"
                  className={cx(classes.g_out_black, classes.small_btn, classes.register_btn)}
                >
                  {intl.formatMessage({ id: "Sign Up" })}
                </Button>
                <DownloadPopoverRC style={{ height: 24 }}>
                  <span>
                    <svg data-src={download} width={24} height={24} className={classes.g_svg_stroke} />
                  </span>
                </DownloadPopoverRC>
              </>
            )}
            <SwitchThemeRC />
            <SwitchLangRC langArr={state.langArr} rateArr={state.rateArr} />
          </div>
        ) : (
          <>
            <div className={classes.loged}>
              {window.voox_co ? (
                ""
              ) : (
                <>
                  <div
                    className={classes.header_popover_btn}
                    onMouseEnter={() => mouseEnter("assets")}
                    onMouseLeave={mouseLeave}
                  >
                    <a href={route_map.totalAssets} className={cx(classes.login_btn)} ref={ref_assets}>
                      {intl.formatMessage({ id: "header.assets" })}
                    </a>
                    <div
                      className={cx("header_popover", state.isEnter === "assets" ? classes.showPopover : "")}
                      style={{ right: 0, top: 23 }}
                    >
                      <div className={classes.header_popover_con}>
                        <a href={route_map.totalAssets}>
                          <svg data-src={wallet_icon} />
                          {intl.formatMessage({ id: "totalAssets" })}
                        </a>
                        <a href={route_map.exchangeAccount}>
                          <svg data-src={spot_icon} />
                          {intl.formatMessage({ id: "exchangeAccount" })}
                        </a>
                        <a href={route_map.coAccount}>
                          <svg data-src={futures_icon} />
                          {intl.formatMessage({ id: "coAccount" })}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className={classes.header_popover_btn}
                    onMouseEnter={() => mouseEnter("order")}
                    onMouseLeave={mouseLeave}
                  >
                    <a href={route_map.exchangeOrder} className={classes.login_btn}>
                      {intl.formatMessage({ id: "header.order" })}
                    </a>
                    <div
                      className={cx("header_popover", state.isEnter === "order" ? classes.showPopover : "")}
                      style={{ right: 0, top: 23 }}
                    >
                      <div className={classes.header_popover_con}>
                        <a href={route_map.exchangeOrder}>
                          <svg data-src={spot_icon} />
                          {intl.formatMessage({ id: "exchangeOrder" })}
                        </a>
                        <a href={route_map.coOrder}>
                          <svg data-src={futures_icon} />
                          {intl.formatMessage({ id: "coOrder" })}
                        </a>
                      </div>
                    </div>
                  </div>

                  <DownloadPopoverRC style={{ height: 24 }}>
                    <span ref={ref_download} className={classes.header_svg}>
                      <svg data-src={download} width={24} height={24} className={classes.g_svg_stroke} />
                    </span>
                  </DownloadPopoverRC>
                </>
              )}
              <SwitchThemeRC />
              {window.voox_co ? (
                ""
              ) : (
                <div
                  className={classes.header_popover_btn}
                  style={{ height: 24 }}
                  onMouseEnter={() => mouseEnter("message")}
                  onMouseLeave={mouseLeave}
                >
                  <a href={route_map.message} className={classes.header_svg}>
                    <Badge
                      classes={{ dot: classes.badge_dot }}
                      color="primary"
                      variant="dot"
                      invisible={!(state.message && state.message.length > 0)}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <svg data-src={svg_message} width={24} height={24} className={classes.g_svg_stroke}></svg>
                    </Badge>
                  </a>
                  {state.message.length ? (
                    <div
                      className={cx("header_popover", state.isEnter === "message" ? classes.showPopover : "")}
                      style={{ right: 0, top: 23 }}
                    >
                      <div className={classes.header_popover_message}>
                        <ul>
                          {state.message.map((item, i) => {
                            return (
                              <li key={`message${i}`}>
                                <a href={route_map.message}>{item.messageContent}</a>
                              </li>
                            );
                          })}
                        </ul>
                        <div>
                          <a href={route_map.message}>
                            {intl.formatMessage({ id: "more" })} <svg data-src={svg_right} width={16} height={16}></svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
              {window.voox_co ? (
                ""
              ) : (
                <div
                  className={classes.header_popover_btn}
                  style={{ height: 24 }}
                  onMouseEnter={() => mouseEnter("userManagement")}
                  onMouseLeave={mouseLeave}
                >
                  <a href={route_map.personal_userManagement} className={classes.header_svg}>
                    <svg data-src={svg_contract} width={24} height={24} className={classes.g_svg_stroke}></svg>
                  </a>
                  <div
                    className={cx("header_popover", state.isEnter === "userManagement" ? classes.showPopover : "")}
                    style={{ right: 0, top: 23 }}
                  >
                    <div className={classes.header_popover_user}>
                      <div>
                        <strong
                          onClick={() => {
                            window.location.href = route_map.personal_userManagement;
                          }}
                        >
                          {userinfo.email || userinfo.mobileNumber}
                        </strong>
                        <span
                          style={{
                            display: "inline-flex",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                        >
                          UID: {userinfo.id}
                          <CopyToClipboard text={userinfo.id} onCopy={copy}>
                            <svg data-src={svg_copy} width={20} height={20} className={classes.g_svg_stroke}></svg>
                          </CopyToClipboard>
                        </span>
                      </div>
                      <a href={route_map.personal_userManagement}>
                        <span>
                          <svg data-src={svg_contract} width={24} height={24} className={classes.g_svg_stroke}></svg>{" "}
                        </span>
                        <strong>{intl.formatMessage({ id: "header.u.account" })}</strong>
                      </a>
                      <a href={route_map.myrate} style={{ height: 82 }}>
                        <span>
                          <svg data-src={svg_fee} width={24} height={24} className={classes.g_svg_stroke}></svg>{" "}
                        </span>
                        <strong>
                          {intl.formatMessage({ id: "header.u.fee" })}
                          <span style={{ whiteSpace: "nowrap" }}>
                            <svg data-src={svg_fee_l1} width={16} height={16}></svg>
                            {userinfo?.levelName}
                          </span>
                        </strong>
                      </a>
                      <a href={route_map.bonus}>
                        <Svgbonus /> {intl.formatMessage({ id: "header.u.bonus" })}
                      </a>
                      <a href={route_map.inviteFriends}>
                        <span>
                          <svg data-src={svg_invite} width={24} height={24} className={classes.g_svg_stroke}></svg>
                        </span>
                        <strong>{intl.formatMessage({ id: "header.u.invite" })}</strong>
                      </a>
                      {/* <a href={route_map.personal_apiManagement}>
                      <svg data-src={svg_api} width={24} height={24} className={classes.g_svg_stroke}></svg>
                      <strong>{intl.formatMessage({ id: "header.u.api" })}</strong>
                    </a> */}
                      <a href="#" onClick={logout}>
                        <span>
                          <svg data-src={svg_logout} width={24} height={24} className={classes.g_svg_stroke}></svg>
                        </span>
                        <strong>{intl.formatMessage({ id: "header.u.logout" })}</strong>
                      </a>
                    </div>
                  </div>
                </div>
              )}
              <SwitchLangRC langArr={state.langArr} rateArr={state.rateArr} />
            </div>
          </>
        )}
      </div>
    </header>
  );
}

export default HeaderRC;
